<div>
     <app-job-side-preview></app-job-side-preview>
  <app-job-details></app-job-details>
  </div>